import AccessDenied from '@components/AccessDenied'
import Dashboard from '@dashboard/views/Dashboard'
import ExpensesRouter from '@views/expenseReports/ExpensesRouter'
import SendMoney from '@withdrawals/views/SendMoney'
import { paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'
import React from 'react'
import { logoutAnd404Routes } from './non-protected-routes'

const ProfileSettings = React.lazy(() => import('@views/settings/ProfileSettings/ProfileSettings'))

const Accounts = React.lazy(() => import('@views/accounts/Accounts'))
const Exchange = React.lazy(() => import('@views/banking/Exchange'))
const Transactions = React.lazy(() => import('@views/transactions/TransactionsWrapper'))

// const ScanAndPay = React.lazy(() => import('@views/scanAndPay/ScanAndPay'))
// const P2PQrCodePage = React.lazy(() => import('@views/scanAndPay/QRPayment'))

const Recipients = React.lazy(() => import('@views/recipients/Recipients'))
const RecipientsDetails = React.lazy(() => import('@views/recipients/RecipientDetailsPage'))

const Invoices = React.lazy(() => import('@views/invoices/Invoices'))
const InvoiceEdit = React.lazy(() => import('@views/invoices/InvoiceEdit/InvoiceEdit'))
const InvoiceUploadedEdit = React.lazy(() => import('@views/invoices/InvoiceUploadedEdit/InvoiceUploadedEdit'))
const InvoicesCustomerWrapper = React.lazy(
  () => import('@views/invoices/InvoicesCustomerWrapper/InvoicesCustomerWrapper')
)

const ExpensePayment = React.lazy(() => import('@views/expensePayments/ExpensePayment'))
const ExpensePayments = React.lazy(() => import('@views/expensePayments/ExpensePayments'))
const ExpenseReportDetails = React.lazy(() => import('@views/expenseReports/ExpenseReportDetails'))
const CounterpartyDetails = React.lazy(() => import('@views/counterparty/CounterpartyPage/CounterpartyPage'))

const SupportView = React.lazy(() => import('@modules/support/views/SupportView/SupportView'))

export const staffRoutes: RouteDefinition[] = [
  { path: paths.root(), component: Dashboard },

  // { path: paths.scanAndPay(), component: ScanAndPay },
  // { path: paths.p2pQrCode(), component: P2PQrCodePage },
  { path: paths.scanAndPay(), component: AccessDenied },
  { path: paths.p2pQrCode(), component: AccessDenied },
  { path: paths.dashboard(), component: Dashboard },
  { path: paths.profile(), component: ProfileSettings },
  { path: `${paths.profile()}/security`, component: ProfileSettings },
  { path: `${paths.profile()}/notifications`, component: ProfileSettings },

  { path: paths.crypto.root(), component: React.lazy(() => import('@views/crypto/CryptoTrading')) },

  { path: paths.banking.deposit(), component: React.lazy(() => import('@deposit/views/Deposit')) },

  { path: paths.banking.exchangeFromTo(':fromCurrency', ':toCurrency'), component: Exchange },
  { path: paths.banking.exchange(), component: Exchange },

  // { path: paths.banking.sendBankTransfer(), component: SendMoney },
  // { path: paths.banking.sendCrypto(), component: SendMoney },
  // { path: paths.banking.sendDigitalWallet(), component: SendMoney },
  // { path: paths.banking.sendInterac(), component: SendMoney },
  // { path: paths.banking.sendInternalTransfer(), component: SendMoney },
  // { path: paths.banking.sendIntraAccountTransfer(), component: SendMoney },
  // { path: paths.banking.sendJetonWallet(), component: SendMoney },
  // { path: paths.banking.sendPerfectMoney(), component: SendMoney },
  // { path: paths.banking.sendPix(), component: SendMoney },
  // { path: paths.banking.sendToLinkedAccount(), component: SendMoney, params: { subAccounts: true } },
  { path: paths.banking.sendTo(':recipientId'), component: SendMoney },
  { path: paths.banking.send(), exact: false, component: SendMoney },

  { path: paths.banking.accounts.list(), component: Accounts },
  { path: paths.banking.transactions.listByAccountId(':accountId'), component: Transactions },
  { path: paths.banking.transactions.list(), component: Transactions },
  // { path: paths.banking.transactions.details(':transactionId'), component: TransactionDetails },

  { path: paths.invoicesCustomersWrapper(), component: InvoicesCustomerWrapper },
  { path: paths.invoicesCustomersWrapper() + paths.customers(), component: InvoicesCustomerWrapper },
  { path: paths.invoicesCustomersWrapper() + paths.invoices.list(), component: InvoicesCustomerWrapper },

  { path: paths.invoices.uploadEdit(':invoiceId'), component: InvoiceUploadedEdit },
  { path: paths.invoices.upload(), component: InvoiceUploadedEdit },
  { path: paths.invoices.addForCustomer(':customerId'), component: InvoiceEdit },
  { path: paths.invoices.add(), component: InvoiceEdit },
  { path: paths.invoices.send(':invoiceId'), component: React.lazy(() => import('@views/invoices/InvoiceSend')) },
  { path: paths.invoices.edit(':invoiceId'), component: InvoiceEdit },
  { path: paths.invoices.listByStatus(':status'), component: Invoices },

  { path: paths.cards.cardLink(), component: React.lazy(() => import('@cards/views/CardLink')) },
  { path: paths.cards.cardOrder(), component: React.lazy(() => import('@cards/views/CardOrder')) },
  { path: paths.cards.cardList(), component: React.lazy(() => import('@cards/views/Cards')) },

  { path: paths.banking.finalStatus.fail(':method'), component: React.lazy(() => import('@views/transaction_failed')) },
  {
    path: paths.banking.finalStatus.success(':method'),
    component: React.lazy(() => import('@views/transaction_success'))
  },

  { path: paths.expenseManagement.counterpartyDetails(':counterpartyId'), component: CounterpartyDetails },
  { path: paths.expenseManagement.counterparties(), component: ExpensesRouter },
  { path: paths.expenseManagement.reportDetails(':reportId'), component: ExpenseReportDetails },
  { path: paths.expenseManagement.reports(), component: ExpensesRouter },
  { path: paths.expenseManagement.payments(':reportId'), component: ExpensePayments },
  { path: paths.expenseManagement.pay(), component: ExpensePayment },
  { path: paths.expenseManagement.dashboard(), component: ExpensesRouter },

  { path: paths.recipients.details(':recipientId'), component: RecipientsDetails },
  { path: paths.recipients.list(), component: Recipients },

  { path: `${paths.support.tickets()}/:ticketId?`, component: SupportView },

  ...logoutAnd404Routes
]
